export default "__VITE_ASSET__BwyDWPQ___"